"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UserSelectionCss = _interopRequireDefault(require("./UserSelection.css.js"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _QuickLinks = _interopRequireDefault(require("./QuickLinks"));

var _LegalTerms = _interopRequireDefault(require("./LegalTerms"));

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

var _reactRouterDom = require("react-router-dom");

var _useClickSubmit = _interopRequireDefault(require("../utils/useClickSubmit"));

var _useInsightSubmit = _interopRequireDefault(require("../utils/useInsightSubmit"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UserSelection = function UserSelection(_ref) {
  var theme = _ref.theme,
      offer = _ref.offer,
      tracking = _ref.tracking,
      email = _ref.email;
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabledState = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      interest = _useState4[0],
      setInterest = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shouldExecute = _useState6[0],
      setExecute = _useState6[1];

  (0, _useClickSubmit.default)(tracking, email, shouldExecute);
  (0, _useInsightSubmit.default)(interest, tracking, shouldExecute);

  var handleInputChange = function handleInputChange(event) {
    var interestValue = event.target.value;
    var query = (0, _bluekeelControllers.flattenLongString)(interestValue);
    setInterest(query);

    if (interestValue !== '') {
      setDisabledState(false);
      return;
    }

    ;
    setDisabledState(true);
  };

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    if (disabled) return;
    setExecute(true);
    var linkout = (0, _bluekeelControllers.buildKeywordLink)(offer.url, tracking, interest);
    var jumpBehind = (0, _bluekeelControllers.buildKeywordLink)(offer.jump, tracking, interest);
    var newTab = window.open();
    newTab.location = linkout;

    if (jumpBehind && jumpBehind !== 'N/A') {
      window.location.href = jumpBehind;
    } else {
      history.push('/verticals');
    }

    ;
  };

  var themedButton = Object.assign({}, _UserSelectionCss.default['submitButton'], _UserSelectionCss.default["".concat(theme, "Button")]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.formCard
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.titleText
  }, "".concat(offer.question_text || 'What are you interested in?')), /*#__PURE__*/_react.default.createElement("form", {
    style: _UserSelectionCss.default.formContainer,
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/_react.default.createElement(_QuickLinks.default, {
    quickLinks: offer.selection_links,
    theme: theme,
    tracking: tracking,
    email: email
  }), /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    value: interest,
    handleChange: handleInputChange,
    name: "Search"
  }), /*#__PURE__*/_react.default.createElement(_LegalTerms.default, {
    email: email
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.buttonGroup
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    style: disabled ? _UserSelectionCss.default['disabledButton'] : themedButton
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: _UserSelectionCss.default.buttonText
  }, "Next"), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fal', 'angle-double-right'],
    style: _UserSelectionCss.default.buttonIcon
  })))));
};

var _default = (0, _radium.default)(UserSelection);

exports.default = _default;

//# sourceMappingURL=UserSelection.jsx.map